import { Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import DtoVigilance from '../../dto/DtoVigilance'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { METEOALARM_COLORS } from '../contents/VigilenceConstants'
import { capitalize } from 'lodash'
import { vigilancesPath } from 'conf/SieauConstants'

const VigilanceCard = ({
    vigilance,
    index,
    size,
    containerStyle = {},
}) => {
    const color = useMemo(() => {
        const match = vigilance.url.match(/wflag-(l\d)-/)
        return match ? METEOALARM_COLORS[match[1]] ?? 'transparent' : 'transparent'
    }, [vigilance.url])

    const isLast = index === size - 1
    return (
        <Grid
            container
            size={12}
            spacing={1}
            sx={{
                cursor: 'pointer',
                borderBottom: isLast ? '' : 'solid grey 1px',
                ...containerStyle,
            }}
            onClick={() => window.open(vigilancesPath, '_blank')}
        >
            <Grid
                alignItems='center'
                container
                sx={{
                    backgroundColor: color,
                    borderTopLeftRadius: index === 0 ? 4 : 0,
                    borderBottomLeftRadius: isLast ? 4 : 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img src={vigilance.url} alt='vigilanceImage' style={{
                    padding: '5',
                }}
                />
            </Grid>
            <Grid
                container
                size={'grow'}
                paddingY={1}
                spacing={0}
                sx={{ paddingRight: 1 }}
            >
                <Grid size={'grow'}>
                    <Typography fontWeight={'bold'}>{`${capitalize(vigilance.info)} - ${vigilance.locationName} (${vigilance.locationCode})`}</Typography>
                </Grid>
                <OpenInNewIcon/>
                <Grid size={12}>
                    <Typography>{`${i18n.fromDate} ${vigilance.start} ${i18n.to} ${vigilance.end}`}</Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}

VigilanceCard.propTypes = {
    vigilance: PropTypes.instanceOf(DtoVigilance),
    index: PropTypes.number,
    size: PropTypes.number,
    containerStyle: PropTypes.shape({}),
}

export default VigilanceCard
